import styled from 'styled-components';

import { text } from 'quarks/interpolations/text';

const Text = styled.span`
  ${text}
`;

export default Text;
